export const validateApprovalError = (errors = []) => {
  let isHazmat = false;
  let isDeclared = false;
  const messages = [];

  if (!Array.isArray(errors)) {
    return { isHazmat, isDeclared, messages, requiresApproval: false };
  }

  errors.forEach(({ rule_type, error }) => {
    if (rule_type === "HAZMAT") {
      isHazmat = true;
    }

    if (rule_type === "DECLARED_VALUE") {
      isDeclared = true;
    }

    if (error) {
      messages.push(error);
    }
  });

  return {
    isHazmat,
    isDeclared,
    messages,
    requiresApproval: isHazmat || isDeclared,
  };
};